<template>
  <v-form v-model="valid" ref="DialogForm">
    <slotted-dialog :title="$t('servicesystem.common_objects.customer.new')" :externaltrigger="dialogtrigger"
      :externalCloseTrigger="closetrigger" :persistent="true">
      <template v-slot:content>
        <v-container fluid :key="dialogtrigger">

          <UsedAlert :usedConfig="usedConfig">
          </UsedAlert>

          <v-row>
            <v-col>
              <QTextField v-model="editObject.Id" :label="$t('servicesystem.common_objects.customer.customer_number')"
                :externaledit="true" :rules="[requiredRule]"
                :errormessages="usedConfig ? [usedConfig.message] : undefined" @DebouncedInput="checkCustomerId">
              </QTextField>
            </v-col>
            <v-col>
              <QTextField v-model="editObject.OrganisationNumber"
                :label="$t('servicesystem.common_objects.customer.organization_number')" :externaledit="true">
              </QTextField>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <QTextField v-model="editObject.Name" :label="$t('servicesystem.common_objects.customer.customer_name')"
                :externaledit="true" :rules="[requiredRule]">
              </QTextField>
            </v-col>
          </v-row>
          <AdvancedExpancion>
            <v-row>
              <v-col>
                <QTextField v-model="editObject.Longitude"
                  :label="$t('servicesystem.common_objects.customer.longitude')" :externaledit="true">
                </QTextField>
              </v-col>
              <v-col>
                <QTextField v-model="editObject.Latitude" :label="$t('servicesystem.common_objects.customer.latitude')"
                  :externaledit="true">
                </QTextField>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <QSwitchInput v-model="editObject.FreeFromVat"
                  :label="$t('servicesystem.common_objects.customer.free_from_vat')" :externaledit="true">
                </QSwitchInput>
              </v-col>
              <v-col>
                <QSwitchInput v-model="editObject.IsActive" :label="$t('servicesystem.common_objects.customer.active')"
                  :externaledit="true">
                </QSwitchInput>
              </v-col>
            </v-row>
          </AdvancedExpancion>

          <v-row no-gutters>
            <h4>{{ $t("servicesystem.common_objects.address.address") }}</h4>
            <v-col>
              <v-divider class="mt-3 ml-3"></v-divider>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <QTextField v-model="editObject.DefaultDeliveryAddress.Street"
                :label="$t('servicesystem.common_objects.address.street')" :rules="[requiredRule]" externaledit>
              </QTextField>
            </v-col>
            <v-col cols="4">
              <QTextField v-model="editObject.DefaultDeliveryAddress.Zip"
                :label="$t('servicesystem.common_objects.address.zip')" :rules="[requiredRule]" externaledit>
              </QTextField>
            </v-col>
            <v-col cols="8" class="pl-3">
              <QTextField v-model="editObject.DefaultDeliveryAddress.City"
                :label="$t('servicesystem.common_objects.address.city')" :rules="[requiredRule]" externaledit>
              </QTextField>
            </v-col>
            <v-col cols="12">
              <QTextField v-model="editObject.DefaultDeliveryAddress.Country"
                :label="$t('servicesystem.common_objects.address.country')" externaledit>
              </QTextField>
            </v-col>
          </v-row>

        </v-container>
      </template>

      <template v-slot:buttons>
        <v-btn @click="closetrigger++" color="primary" outlined
          v-text="$t('servicesystem.common_objects.commonterms.cancel')">
        </v-btn>
        <v-btn @click="valid ? create() : null" :loading="loading" :disabled="loading"
          :color="valid ? 'primary' : 'disabled'">{{ $t('servicesystem.common_objects.commonterms.create') }}</v-btn>
      </template>

    </slotted-dialog>
  </v-form>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";
import AdvancedExpancion from "@/components/Dialogs/AdvancedExpancion.vue";
//import AddressEdit from "@/components/Preview/Customer/AddressEdit.vue";
//import ContactEdit from "@/components/Preview/Customer/ContactEdit.vue";
import UsedAlert from "@/components/UsedAlert.vue";

export default {
  name: "NewCustomerDialog",
  props: {
    externaltrigger: Number,
    name: String,
  },
  components: {
    SlottedDialog,
    AdvancedExpancion,
    //AddressEdit,
    //ContactEdit,
    UsedAlert,
  },
  mixins: [clientAPI],

  data() {
    return {
      dialogtrigger: 0,
      closetrigger: 0,
      editObject: {
        DefaultDeliveryAddress: {},
      },
      valid: false,
      loading: false,
      used: null,
    };
  },

  mounted() { },

  methods: {
    setdefault() {
      this.used = null;
      this.editObject = { Name: this.name, DefaultDeliveryAddress: {}, IsActive: true };
    },

    create() {
      var dto = Object.assign({}, this.editObject);
      //console.log("Sendt", dto);
      this.createCustomer(dto)
        .then((response) => {
          this.$emit("Created", response);
        })
        .catch(() => { });
    },

    async checkCustomerId(id) {
      if (!id) {
        this.used = null;
      } else {
        await this.getCustomerById(id)
          .then((response) => {
            //console.log(response);
            this.used = response;
          })
          .catch((e) => {
            if (e.status == 204) {
              this.used = null;
            }
            else {
              console.error(e)
            }
          });
      }
    },
  },

  computed: {
    isOld() {
      return this.editObject && this.editObject.Id && this.editObject.Id > -1;
    },

    usedConfig() {
      if (this.used) {
        return {
          message: this.$t('servicesystem.common_objects.customer.customer_number_in_use', { kkey: this.$t('servicesystem.common_objects.customer.customer_number'), ckey: this.used.Name }),
          openText: this.$t('servicesystem.common_objects.customer.view_customer', { ckey: this.used.Name }),
          route: { name: 'ViewCustomer', params: { customerId: this.used.Id } },
        };
      }
      else {
        return null;
      }
    }
  },

  watch: {
    externaltrigger: function () {
      this.setdefault();
      this.dialogtrigger++;
    },

    "$route.name"() {
      this.closetrigger++;
    },
  },
};
</script>